// extracted by mini-css-extract-plugin
export default {"container":"activity_details_actions-module___container___f901ba61"};